import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import baseUrl from "../../utilities/baseUrl";
import LoadingButton from "../../components/Loading/LoadingButton";
import { Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";

const SendSMSForFactor = ({ numberParcel, id, onSuccess }) => {
  const {
    formState: { errors },
    register,
    handleSubmit,
  } = useForm();

  const { mutate, isPending } = useMutation({
    mutationKey: ["print-factor-button"],
    mutationFn: phoneNumber =>
      axios
        .post(baseUrl + "/totalpost/v1/sendSMSForFactor", {
          phoneNumber,
          id,
        })
        .then(res => res.data),

    onSuccess: res => {
      Swal.fire({
        icon: "success",
        text: res.message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "green",
      });
      onSuccess();
    },

    onError: res => {
      let message = "";
      try {
        message = res.response.data.message;
      } catch (error) {
        message = "خطای ارتباط با سرور";
      }

      Swal.fire({
        icon: "error",
        text: message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "red",
      });
    },
  });

  return (
    <form
      onSubmit={handleSubmit(({ phoneNumber }) => {
        mutate(phoneNumber);
      })}
    >
      <Form.Label htmlFor="print-factor-button">
        <span>لطفا جهت دریافت فاکتور مرسوله با شماره سفارش </span>
        <span className="fs-5 fw-bold">{numberParcel}</span>
        <span> شماره تلفن همراه فرستنده یا گیرنده را وارد کنید:</span>
      </Form.Label>
      <div className="d-flex flex-wrap">
        <Col xs={12} lg={9}>
          <Form.Control
            type="text"
            id="print-factor-button"
            className="rounded-0"
            {...register("phoneNumber", {
              required: { value: true, message: "شماره تلفن الزامی" },
              minLength: {
                value: 11,
                message: "شماره همراه باید 11 رقم باشد",
              },
              maxLength: {
                value: 11,
                message: "شماره همراه باید 11 رقم باشد",
              },
              pattern: {
                value: /^09/,
                message: "شماره همراه باید با 09 شروع شود",
              },
            })}
          />
          {errors.phoneNumber && (
            <p className="fs-small text-danger">{errors.phoneNumber.message}</p>
          )}
        </Col>
        <Col xs={12} lg={3}>
          {isPending && (
            <LoadingButton
              className="btn-success-style w-100 rounded-0"
              center
              title="در حال ارسال"
            />
          )}
          {!isPending && (
            <button className="btn-success-style w-100 rounded-0">تایید</button>
          )}
        </Col>
      </div>
    </form>
  );
};

export default SendSMSForFactor;
